/**
 * @module Experience/error-pages
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const COMPONENT_IDS = {
  errorFourZeroFourId: 'errors/404',
  loginErrorId: 'errors/404_account',
  contactUrl: 'https://www.t-mobile.com/contact-us.html',
  errorImageUrl:
    'https://s3-us-west-2.amazonaws.com/images.rebellion.prod/' +
    'General/Prepaid/errorPages/3902-rebellion-error-asset-404.png',
  ACCOUNT_LANDING: '/account-landing',
  BROWSE_DEVICES: '/browse-phones',
  HOME_PAGE: '/',
};

export const ORDER_SUBSTATUS_CODE = {
  ORDER_ERROR: 'ORDER-1030',
  ORDER_INPROCESS: 'ORDER-1031',
  FRAUD_USER: 'ORDER-1033',
  NEGATIVE_FILE_ERROR: '2494',
};

export const PAYMENT_ERROR_CODE = {
  NEGATIVE_CARD_ERROR: '[N0001]',
  NEGATIVE_CCID_ERROR: '[N0002]',
  BLACKOUT_PERIOD_ERROR: '[B0001]',
  CARD_COUNTRY_CODE: '[CC0001]',
  FRAUD_REJECT_ERROR: '[F0001]',
};
